import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./Inner_Page_Banner.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

const Inner_Page_Banner = () => {
  const navigate = useNavigate();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { id } = useParams();
  const { IMG_URL } = useContext(Context);

  const [servicebanner, setServiceBanner] = useState({});

  const getServiceBanner = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setServiceBanner(res?.data || {});
    }
  };

  useEffect(() => {
    if (id) {
      getServiceBanner();
    }
  }, [id]);

  return (
    <section className="residential_service">
      <div className="custom_container">
        {/* Breadcrumb */}
        <div className="breadcrumb_wrapper">
          <span className="breadcrumb_link" onClick={() => navigate(-1)}>
            Service
          </span>
          <span className="breadcrumb_separator"> &gt; </span>
          <span className="breadcrumb_active">
            {htmlToReactParser.parse(servicebanner?.name)}
          </span>
        </div>

        <div className="service_banner">
          <div className="row me-0 ms-0">
            <div className="col-xl-4 col-lg-4 col-md-5 col-sm-6">
              {/* ✅ Image + Overlay Wrapper */}
              <div className="service_banner_div">
                <img
                  src={IDS?.IMG_URL + servicebanner?.image}
                  alt="Residential Rooftop Solar"
                  className="banner_img"
                />

                
              </div>
            </div>

            <div className="col-xl-8 col-md-7">
              {/* ✅ Description BELOW image */}
              <div className="service_description_div">
                <h1 className="banner_heading">
                    {htmlToReactParser.parse(servicebanner?.name)}
                  </h1>
                <h2 className="desc_heading">Service Description:</h2>
                <p className="service_desc">
                  {htmlToReactParser.parse(servicebanner?.description)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inner_Page_Banner;
